import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ListQuest } from '../../../services/lists/list-quest';
import { ListRoles } from '../../../services/lists/list-roles';
import { PlayersService } from '../../../services/players/players';
import { GameInfoService } from '../../../services/games/game-info';
import * as _ from "lodash";
import { FieldBuilder } from '../../../services/fields/field-builder';
import { take } from 'rxjs';
import { Downtime } from '../../../../core/services/times/downtime';
import { AllStatus } from '../../../../core/services/status/all-status';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { environmenProgress } from '../../../../../environments/environment.progress';

@Component({
  selector: 'app-end-game',
  imports: [MatDialogTitle, MatDialogContent, MatDialogClose, MatDialogActions, TranslatePipe, MatProgressBarModule],
  templateUrl: './end-game.html',
  styleUrl: './end-game.scss'
})
export class EndGame implements OnInit {
  readonly dialogRef = inject(MatDialogRef<EndGame>);
  //data = inject<any>(MAT_DIALOG_DATA);

  nameRole: string;
  dataCollection: any;
  isCloseGame: boolean = false;

  listQuest = inject(ListQuest);
  listRoles = inject(ListRoles);
  players = inject(PlayersService);
  gameInfo = inject(GameInfoService);
  field = inject(FieldBuilder);
  downtime = inject(Downtime);
  configuration = inject(ConfigurationService);
  setProgress = environmenProgress;
  
  
  allStatus = inject(AllStatus);
  questInfo: any;
  pdfFiles:boolean = false;
  listFiles: any = [];

  ngOnInit(): void { 
    this.dialogRef.disableClose = true;
    let typeGame = this.gameInfo.gameInfo.type;
    if(typeGame === 'role'){
      this.nameRole = this.getStringRole(this.players.player.rq_id);
    } else{
      this.nameRole = this.getStringQuest(this.players.player.rq_id);
    }
    this.dataCollection = this.gameInfo.gameInfo?.dataCollection.find( (list: any) => list.id === this.players.player.player_id);
    const level = this.countLevel();
    this.questInfo = JSON.parse(sessionStorage.getItem('QuestInfo') as string);
    if(this.questInfo.data?.pdf_files){
      this.listFiles = _.isEmpty(this.questInfo.data?.pdf_files[level]) ? [] : this.questInfo.data?.pdf_files[level];
      this.pdfFiles = true;
      if(this.configuration.configuration.profile.nsp){
        this.filterNsp();
      }else{
        this.filterNotNsp();
      }
    }else{
      this.pdfFiles = false;
    }

  }

  filterNsp(){
      const resF = this.listFiles.filter((item: any) => item.nsp === true );
      if(_.isEmpty(resF)){
        this.filterNotNsp();
      }else{
        this.listFiles = resF;
      }
    }
  
    filterNotNsp(){
      const resF = this.listFiles.filter((item: any) => item.nsp === false );
      if(_.isEmpty(resF)){
        this.pdfFiles = false;
      }else{
        this.listFiles = resF;
      }    
    }

  getStringQuest(rq_id: unknown){
    let result = this.listQuest.findQuest(rq_id as number);
    return result.data.humman_description.title;
  }

  getStringRole(rq_id: unknown){
    let result = this.listRoles.findRole(rq_id as number);
    return result.data.humman_description.title;
  }

  calcLevelPrecent(points: number, maxPoints: number): number{
    let res: number = (points / maxPoints) * 100;
    return parseFloat(res.toFixed(2));
  }

  closeGame(val: boolean){
    this.isCloseGame = val;
    this.downtime.refreshTimer();
  }

  countLevel(): number{
    let count: number = 0;
    if(this.dataCollection.data.levels['first'].maxPoints > 0) count = 1;
    if(this.dataCollection.data.levels['second'].maxPoints > 0) count = 2;
    if(this.dataCollection.data.levels['third'].maxPoints > 0) count = 3;
    if(this.dataCollection.data.levels['fourth'].maxPoints > 0) count = 4;
    if(this.dataCollection.data.levels['fifth'].maxPoints > 0) count = 5;
    if(this.dataCollection.data.levels['sixth'].maxPoints > 0) count = 6;
    if(this.dataCollection.data.levels['seventh'].maxPoints > 0) count = 7;
    return count;
  }

  newOpenLink(event: Event, url: string){
      event.preventDefault();
      this.allStatus.setDisplayProgressSpinner(true);
      this.downtime.refreshTimer();
      this.field.changeLinkPDF(url).pipe(
        take(1)
      ).subscribe((result: any)=>{
        this.allStatus.setDisplayProgressSpinner(false);
        window.open(result.url, '_blank');
      });
    }

  clickIconClose(event: MouseEvent){
      this.closeGame(true);
  }

  yourTxtRating(interest: number){
    let txt = 'txtEmpty';

    this.setProgress.ratings.forEach((item:any) => {
      if(item.valueB <= interest && interest <= item.valueE){
        txt = item.langT;
      }
    });

    return txt;
  }

}
